var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTag = function SvgTag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 41.021 41.021",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3px",
    d: "M0,0H17.509l5.836,5.836-6.253,5.836H0Z",
    transform: "translate(11.673 23.869) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 1.668,
    cy: 1.668,
    r: 1.668,
    transform: "translate(25.013 15.008)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.172 9.172)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3px",
    y1: 6.67,
    transform: "translate(3.335)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3px",
    x2: 6.67,
    transform: "translate(0 3.335)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tag.2c39ab8f.svg";
export { ForwardRef as ReactComponent };